import { httpRequest } from '@v4/http/request';

/**
 * Gets search results
 *
 * @param {string} url
 * @param {object} [opts]
 * @returns {Promise<object>}
 */
export const getSearchResults = (url, opts = {}) =>
    httpRequest({
        url,
        timeout: 2500,
        cache: false,
        ...opts,
    });
